import { render } from "./IdentiteCandidat.vue?vue&type=template&id=e8e209f0"
import script from "./IdentiteCandidat.vue?vue&type=script&lang=js"
export * from "./IdentiteCandidat.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\PLATEFORME-AUTO-PREFEREPLUS\\paprep-spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__